import { render, staticRenderFns } from "./unsalableWarning.vue?vue&type=template&id=dfc7b840"
import script from "./unsalableWarning.vue?vue&type=script&lang=js"
export * from "./unsalableWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports